import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { CryptoService } from '@bt/core/services/crypto.service';
import { CryptoBalanceModel } from '@bt/core/models/cryptoBalance.model';
import { NotifierService } from 'angular-notifier';
import {faPlus, faTimes,faArrowRight, faExclamationCircle} from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormBuilder, Validators, AbstractControl} from "@angular/forms";
import { BinanceService } from '@bt/core/services/binance.service';
import { AssetBalanceModel } from '@bt/core/models/AssetBalance.model';
import { BinanceWithdraw } from '@bt/core';

@Component({
  selector: 'app-binance',
  templateUrl: './binance.component.html',
  styleUrls: ['./binance.component.scss']
})
export class BinanceComponent extends BaseComponent{
  faPlus = faPlus;
  faTimes = faTimes;
  faArrowRight=faArrowRight;
  faExclamationCircle = faExclamationCircle;
  constructor(
    private binanceService: BinanceService,
    private notifierService: NotifierService
  )
  {
    super();
    this.isResponsed = false;
    this.isModalOpened = false;
  }

  public withdraws:BinanceWithdraw[];
  public balances: AssetBalanceModel[];
  public hasBalances: boolean = true;
  public hasWithdraws: boolean = true;
  public isResponsed: boolean;
  public isModalOpened : boolean;
  public canAddWithdraws : boolean=false;
  public reason: string;
  ngOnInit() {
    this.setLoading(true);
    this.loadBalances();
    this.checkWithdrawals()
    let t=this;
    let checkFunction =  function(){
      t.binanceService.checkWithdrawals().then((resp)=>{
        t.canAddWithdraws = resp.data;
        t.reason = t.canAddWithdraws ? '' : resp.errorMsgs[0];
      });
      setTimeout(checkFunction,60*1000);
    }
    setTimeout(checkFunction,10*1000);
  }

  public loadBalances(): void{
    this.binanceService.getAllBalances()
    .then((resp: any) => {
      if(resp.data != null && resp.data.length){
        this.balances = resp.data;
        this.hasBalances = true;
      }else{
        this.hasBalances=false;
      }
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error: any) => {
      this.hasBalances=false;
      this.isResponsed = true;
      this.notifierService.notify('error', error.message);
      this.setLoading(false);
    });
    this.binanceService.getBinanceWithdraws()
    .then((resp: any) => {
      if(resp.data != null && resp.data.length){
        this.withdraws = resp.data;
        this.hasWithdraws = true;
      }else{
        this.hasWithdraws = false;
      }
      this.isResponsed = true;
      this.setLoading(false);
    })
    .catch((error: any) => {
      this.isResponsed = true;
      this.notifierService.notify('error', error.message);
      this.setLoading(false);
    });
  }

  // public copyToClipboard(text: string): void{
  //   const selBox = document.createElement('textarea');
  //   selBox.style.position = 'fixed';
  //   selBox.style.left = '0';
  //   selBox.style.top = '0';
  //   selBox.style.opacity = '0';
  //   selBox.value = text;
  //   document.body.appendChild(selBox);
  //   selBox.focus();
  //   selBox.select();
  //   document.execCommand('copy');
  //   document.body.removeChild(selBox);

  //   this.notifierService.notify('success', 'Адрес скопирован!');
  // }


 public actModal(open: boolean):void{
 this.isModalOpened = open;
  if(open){
    (<any>window).$(".bitmap").removeClass("has-scroll");
  }
  else{
    (<any>window).$(".bitmap").addClass("has-scroll");
  }
}

public checkWithdrawals():void{
  this.binanceService.checkWithdrawals().then((resp)=>{
    this.canAddWithdraws = resp.data;
    this.reason = this.canAddWithdraws ? '' : resp.errorMsgs[0];
  });
}

public createWithdraws(){
  this.binanceService.CreateWithdrawRequest()
  .then((resp: any) => {
    if(resp.data){
      this.notifierService.notify('success', "Запрос на вывод средств успешно создан");
      this.canAddWithdraws=false;
    }
    else{
      this.notifierService.notify('error', resp.errorMsgs[0])
    }
    this.setLoading(false);
  })
  .then(() => {
    this.checkWithdrawals()
  })
  .catch((error: any) => {
    this.notifierService.notify('error', error.error.errorMsgs[0]);
    this.setLoading(false);
  });
}

}



// WEBPACK FOOTER //
// ./src/app/binance/binance.component.ts